import get from 'lodash/get';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectProfileFormInspectionFieldListErrorsKeys } from '../../redux/appointmentForm/selectors';

// this hook is used only for patient form during get care flow
const useGetIsFieldDisabled = () => {
  const invalidFieldKeys = useSelector(
    selectProfileFormInspectionFieldListErrorsKeys,
  );

  const checkIsFieldDisabled = useCallback(
    (fieldName, validateErrors) => {
      const isFieldErrorExists = get(validateErrors, fieldName);

      return !isFieldErrorExists && !invalidFieldKeys.includes(fieldName);
    },
    [invalidFieldKeys],
  );

  return { checkIsFieldDisabled };
};

export default useGetIsFieldDisabled;



// WEBPACK FOOTER //
// ./src/hooks/patient-form/useGetIsFieldDisabled.js